export const FETCH_WUC_TRANSACTIONS = "FETCH_WUC_TRANSACTIONS";
